import { signal, computed, Signal, ReadonlySignal, batch } from "@preact/signals";
import { validateEmail } from "@utils/form";
import { Rating } from "./ratingbarState";

const MIN_TEXT_AREA_LENGTH = 10;
const MAX_TEXT_AREA_LENGTH = 8192;

export type IFeedbackStateType = {
  rating: Rating
  rank: number;
  feedbackText: Signal<string>,
  email?: Signal<string>,
  success?: Signal<boolean>,
}

export type ICreateFeedbackStateReturn = {
  feedback: Signal<IFeedbackStateType>;
  isFeedbackValid: ReadonlySignal<boolean>;
  isEmailValid: ReadonlySignal<boolean>;
  isFeedbackSuccess: ReadonlySignal<boolean>;
  resetFeedbackState: () => void;
}

const defaultUserValues: IFeedbackStateType = {
  rating: 'initial',
  rank: 3,
  feedbackText: signal(''),
  email: signal(''),
  success: signal(false),
}

const createFeedbackState = (): ICreateFeedbackStateReturn => {
  const feedback = signal<IFeedbackStateType>(defaultUserValues);

  const isFeedbackValid = computed(() => MIN_TEXT_AREA_LENGTH <= feedback.value.feedbackText.value.length &&
    feedback.value.feedbackText.value.length <= MAX_TEXT_AREA_LENGTH);

  const isEmailValid = computed(() => {
    const isEmpty = feedback.value.email.value.length == 0;
    const emailRegexMatches = validateEmail(feedback.value.email.value);

    return !isEmpty && emailRegexMatches;
  });

  const isFeedbackSuccess = computed(() => {
    return feedback.value.success.value
  })

  const resetFeedbackState = () => {
    
    batch(() => {
      FeedbackState.value.feedback.value.feedbackText.value = "";
      FeedbackState.value.feedback.value.email.value = "";
      FeedbackState.value.feedback.value.rating = "initial";
      FeedbackState.value.feedback.value.rank = 3;
    })

  }

  return { feedback, isFeedbackValid, isEmailValid, isFeedbackSuccess, resetFeedbackState }
}

export const FeedbackState = signal<ICreateFeedbackStateReturn>(createFeedbackState());

export default FeedbackState;
